import dayjs from "dayjs";
import { IProducaoDiariaDTO } from "../../../types/tendencia";

const ISO = "YYYY-MM-DD";
const DAYS_OF_WEEK = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
export const HEAT_COLORS = ["#FBE3D8", "#F6BFA6", "#EF9670", "#E0622E", "#A9370F"];

// Lê só a parte da data para não deslocar o dia por fuso horário
export const dayKey = (value?: string) => (value || "").slice(0, 10);

export const ContinuousCalendar = ({
  data = [],
}: {
  data?: IProducaoDiariaDTO[];
}) => {
  const first = dayjs(dayKey(data[0]?.data) || undefined).startOf("month");
  const today = dayjs().format(ISO);
  const totals = new Map(data.map((d) => [dayKey(d.data), d.qtdTotal]));
  const worked = data.map((d) => d.qtdTotal).filter((v) => v > 0);
  const min = Math.min(...worked);
  const max = Math.max(...worked);

  const days = [
    ...Array<null>(first.day()).fill(null),
    ...Array.from({ length: first.daysInMonth() }, (_, i) => first.add(i, "day")),
  ];

  return (
    <div className="flex flex-col gap-1.5">
      <div className="grid grid-cols-7 gap-1.5 text-xs font-semibold uppercase tracking-wider text-[#6B6B66]">
        {DAYS_OF_WEEK.map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {days.map((day, i) => {
          if (!day) return <span key={`empty-${i}`} />;

          const key = day.format(ISO);
          const value = totals.get(key);
          let style = "border border-transparent bg-[#F1F0EC] text-[#6B6B66]";
          let bg: string | undefined;

          if (value) {
            const idx = max > min ? Math.round(((value - min) / (max - min)) * 4) : 4;
            bg = HEAT_COLORS[idx];
            style = `border border-transparent ${idx === 4 ? "text-white" : "text-[#1D1D1B]"}`;
          } else if (value === undefined && key > today) {
            style = "border border-dashed border-[#BDBCB6] bg-white text-[#8A8A84]";
          }
          if (key === today) style += " !border-2 !border-solid !border-[#1D1D1B]";

          return (
            <div
              key={key}
              className={`flex h-[60px] flex-col justify-between rounded-[10px] px-2 py-1.5 tabular-nums ${style}`}
              style={{ background: bg }}
            >
              <span className="text-[11px] font-medium">{day.date()}</span>
              <span className="text-right text-base font-bold">
                {value === undefined ? "—" : value.toLocaleString("pt-BR")}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
